export type PersonaExperience = 'never' | 'casual' | 'power';

export type PersonaInput = {
  role: string;
  experience: PersonaExperience;
  goal?: string;
};

export function buildPersonaString(input: PersonaInput): string {
  const parts: string[] = [];
  parts.push(`Role: ${input.role}.`);
  parts.push(`Notion experience: ${input.experience}.`);
  const trimmed = input.goal?.trim();
  if (trimmed) {
    parts.push(`What they want from this training: ${trimmed}`);
  }
  return parts.join(' ');
}
